import React from "react";
import { NotFoundPage } from '@kursk/components/pages/404/NotFoundPage';
import { getConfig } from "@root/config/config";
import { regionContent } from "@kursk/content/regionContent";
import { LayoutByIframe } from "@kursk/components/ui/LayoutByIframe/LayoutByIframe";

const config = getConfig();

export const PrivacyPolicy = () => {
  if (!regionContent.policyFilePath) {
    return <NotFoundPage />;
  }

  return <LayoutByIframe config={config} filePath={regionContent.policyFilePath} />
}
